import * as React from 'react';

type Props = {
  className?: string;
};

const EmailFilledIcon: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="27px"
    height="18px"
    viewBox="0 0 27 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M17.3035682,9.77586282 L25.2533436,17.7635846 L0.85379449,17.7635846 L8.8035697,9.77586282 L12.6361583,13.3428265 C12.8703031,13.5644562 13.2368348,13.5644562 13.4709796,13.3428265 L13.4709796,13.3428265 L17.3035682,9.77586282 Z M0,1.58891928 L7.92133088,8.95054332 L0,16.9002883 L0,1.58891928 Z M26.1071365,1.58891928 L26.1071365,16.9002883 L18.1858073,8.95054332 L26.1071365,1.58891928 Z M25.2058953,0.763584608 L13.0535689,12.0716213 L0.901242696,0.763584608 L25.2058953,0.763584608 Z"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default EmailFilledIcon;
